import Box from '@mui/material/Box';
import CircularProgress from '@mui/material/CircularProgress';
import { Navigate, Outlet, useLocation } from 'react-router-dom';

import { ROUTES } from '@/app/routes';

import { useAuth } from './useAuth';

/**
 * Closes everything behind it to anyone not signed in.
 *
 * The address that was wanted is remembered, so signing in returns the person
 * there rather than dumping them on the dashboard.
 */
export function RequireAuth() {
  const { user, loading } = useAuth();
  const location = useLocation();

  if (loading) {
    return (
      <Box sx={{ display: 'flex', justifyContent: 'center', py: 8 }}>
        <CircularProgress aria-label="Loading" />
      </Box>
    );
  }

  if (!user) {
    return (
      <Navigate
        to={ROUTES.signIn}
        replace
        // The whole address, not only the path. Keeping just the pathname threw
        // away the search and the hash, so somebody sent to sign in from a
        // filtered, paged list came back to an unfiltered one.
        state={{ from: location.pathname + location.search + location.hash }}
      />
    );
  }

  return <Outlet />;
}
